import styled from "styled-components";

export const StyledMain = styled.div`
  .main-container {
    width: 1400px;
    min-width: 1400px;
    margin: 0 auto;
  }
`;
